import type { ModuleManifest } from '../types';
import { routes } from './routes';
import { navItems } from './nav';
import { COLLECTIONS } from '../../config/collections';

const insuranceModule: ModuleManifest = {
  id: 'P20',
  name: 'Insurance',
  shortName: 'Insurance',
  description: 'Policy management, vendor COIs, customer certificates, claims, and portals',
  icon: 'FileShield',
  status: 'live',
  urlPrefix: '/insurance',
  routes,
  navItems,
  collections: {
    COI_CERTIFICATES: COLLECTIONS.COI_CERTIFICATES,
    COI_REQUIREMENTS: COLLECTIONS.COI_REQUIREMENTS,
    INSURANCE_POLICIES: COLLECTIONS.INSURANCE_POLICIES,
    INSURANCE_CLAIMS: COLLECTIONS.INSURANCE_CLAIMS,
    INSURANCE_PORTALS: COLLECTIONS.INSURANCE_PORTALS,
  },
};

export default insuranceModule;
